import type { PaymentRecord } from '../../../types'
import type { RowAction } from '../../../components/ui/RowActionsMenu'
import { PaymentRow } from './PaymentRow'
import { PaymentsTableHeader } from './PaymentsTableHeader'
import { PAYMENTS_MIN_WIDTH } from './paymentsTableLayout'

type PaymentsTableProps = {
  payments: PaymentRecord[]
  selectedId: string | null
  onSelect: (id: string) => void
  buildRowActions: (payment: PaymentRecord) => RowAction[]
}

export const PaymentsTable = ({
  payments,
  selectedId,
  onSelect,
  buildRowActions,
}: PaymentsTableProps) => (
  <section className="flex w-full flex-col gap-[18px] rounded-[12px] bg-white p-[10px]">
    <div className="overflow-x-auto">
      <div className="flex flex-col gap-[11px]" style={{ minWidth: PAYMENTS_MIN_WIDTH }}>
        <PaymentsTableHeader />

        {payments.length === 0 ? (
          <p className="py-[40px] text-center font-host text-[16px] font-normal leading-normal text-dash-col-head">
            No payments match the current filters.
          </p>
        ) : (
          payments.map((payment) => (
            <PaymentRow
              key={payment.id}
              actions={buildRowActions(payment)}
              onSelect={() => onSelect(payment.id)}
              payment={payment}
              selected={payment.id === selectedId}
            />
          ))
        )}
      </div>
    </div>
  </section>
)
